<template>
  <div :class="$style.container">
    <div :class="$style.header">
      <div :class="$style.title">
        Название группы: {{ apartmentsGroup.number }}
      </div>
      <div :class="$style.title">
        Кол-во помещений: {{ apartmentsGroup.apartments.length }}
      </div>
      <div :class="$style.actions">
        <div :class="$style.action">
          <vs-button
            size="small"
            type="border"
            iconPack="feather"
            icon="icon-edit"
            title="Изменить"
            @click="onEdit"
          />
        </div>
        <div :class="$style.action">
          <vs-button
            size="small"
            type="border"
            iconPack="feather"
            icon="icon-trash"
            title="Удалить"
            @click="onDelete"
          />
        </div>
      </div>
    </div>
    <div :class="$style.list">
      <ag-grid-table
        ref="table"
        :getData="getApartments"
        :columns="apartmentsColumns"
        :rowsHeight="50"
        no-data-text="Нет помещений"
      />
    </div>
  </div>
</template>

<script>
import TypeRenderer        from "@/components/employee/accounts/TypeRenderer";
import * as apartmentTypes from "@/client/dictionaries/apartmentTypes";

export default {
  name:    "ApartmentsGroup",
  props:   ['apartmentsGroup'],
  data() {
    return {
      apartmentsColumns: [
        {
          headerName:  '№',
          headerClass: 'left',
          cellClass:   'left',
          field:       'number',
          minWidth:    85,
          // width:       85,
        },
        {
          headerName:            'Тип',
          field:                 'type_apart',
          cellRendererFramework: TypeRenderer,
          filter:                'select',
          filterParams:          {
            options: apartmentTypes.getSelectOptions(),
          },
        },
        {
          headerName:  'Счет',
          headerClass: 'left',
          cellClass:   'left',
          field:       'account_number',
          minWidth:    100,
          // width:       100,
        },
        {
          headerName:  'Собственник',
          field:       'b_owner',
          headerClass: 'left',
          cellClass:   'left',
          flex:        2,
          // minWidth:    320,
        },
      ],
    };
  },
  methods: {
    getApartments() {
      return Promise.resolve(this.apartmentsGroup.apartments);
    },
    onEdit() {
      const buildingId = this.apartmentsGroup.building_id;
      const apartmentGroupId = this.apartmentsGroup.id;
      this.$http.get(`apartments_groups/${apartmentGroupId}`)
        .then(( { data: apartmentGroup } ) => this.$modal.open({
          size:           'lg',
          title:          'Изменить группу помещений',
          component:      () => import('@/components/employee/apartments-groups/ApartmentsGroupsFormPopup'),
          componentProps: {
            buttonText: 'Сохранить',
            buildingId,
            title:      apartmentGroup.number,
            apartments: apartmentGroup.apartments.map(apartment => apartment.id),
            onSubmit:   ( data ) => {
              return this.$http.put(`apartments_groups/${apartmentGroupId}`, {
                building_id:    buildingId,
                number:         data.title,
                apartments_ids: data.apartments,
              }).then(() => this.$emit('update'));
            },
          },
        }))
        .catch(this.notifyHttpError)
        .catch(() => {});
    },

    onDelete() {
      const apartmentGroupId = this.apartmentsGroup.id;
      return this.$modal.openConfirm({
        message:    'Вы действительно хотите удалить группу помещений?',
        buttonText: 'Удалить',
      }).result
        .then(() => this.$http.delete(`apartments_groups/${apartmentGroupId}`))
        .then(() => this.$emit('update'))
        .catch(this.notifyHttpError)
        .catch(() => {});
    },
  },
  watch:   {
    apartmentsGroup() {
      this.$refs.table.updateRows();
    },
  },
};
</script>

<style lang="scss" module>
.container {
  border: 1px solid #8C8C8C;
}

.header {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  font-size: 1.3em;
  font-weight: 500;
}

.title {
  width: 40%;
  padding-right: 20px;
}

.actions {
  margin-left: auto;
  display: flex;
}

.action {
  margin-left: 5px;
}

.list {
  height: 400px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>
